import CustomSegment from "../../../../components/ui/CustomSegment";
import { useSegment } from "../../../../hooks/useSegment";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { SegmentedType } from "../../../../types";
import AttendanceSettings from "./_components/AttendanceSettings";
import DailyAttendance from "./_components/DailyAttendance";

type SegmentType = "daily-attendance" | "settings";

const AttendanceManagement = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    "attendance-segment",
    "daily-attendance",
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      key: "daily-attendance",
      label: "Daily Attendance",
      element: <DailyAttendance />,
    },
    {
      key: "settings",
      label: "Attendance Settings",
      element: <AttendanceSettings />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.key === segment);

  return (
    <SidebarLayout title="Attendance Management">
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.element}</div>
    </SidebarLayout>
  );
};

export default AttendanceManagement;
